import React from 'react';

import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../../../../../utils';

import { useTheme } from '../../../../../theme';

import { InfoMessageTypeEnum } from '@websky/graphql';

import { AcceptCheckinRules } from '../AcceptCheckinRules';
import Notification from '../../../../../Notification';
import { BaseButton } from '../../../../../BaseComponents';
import { CdnIcon } from '@shared/ui';

import { useStartCheckIn } from '../../lib/useStartCheckIn';

const StartCheckInNotification: React.FC = ({}) => {
	const { t } = useTranslation('OrderCard');
	const { StartCheckInNotification: css } = useTheme('Features').StartCheckIn;

	const isMobile = useIsMobile();

	const {
		loading,
		isRulesModalOpen,
		closeRulesModal,
		checkinRules,
		acceptRules,
		goToCheckin,
		isCheckinAvailable
	} = useStartCheckIn();

	if (!isCheckinAvailable) {
		return null;
	}

	return (
		<>
			<div className={css.root}>
				<Notification
					type="context"
					status={InfoMessageTypeEnum.Info}
					actionText={t('Check-in')}
					actionVariant="optionAction"
					actionLoading={loading}
					icon={<CdnIcon icon="Document/Boarding pass" />}
					infoMessage={{
						text: t('Online check-in started'),
						type: InfoMessageTypeEnum.Info,
						code: 'start-check-in'
					}}
					className={css.notification}
					contextClassName={css.notification__context}
					textClassName={css.notification__text}
					iconClassName={css.notification__icon}
					actionClassName={css.notification__button}
					onClickAction={goToCheckin}
				/>
				{isMobile && (
					<BaseButton
						variant="action"
						isLoading={loading}
						onClick={goToCheckin}
						classes={{ root: css.button }}
					>
						{t('Check-in')}
					</BaseButton>
				)}
			</div>
			{checkinRules && (
				<AcceptCheckinRules
					isOpen={isRulesModalOpen}
					rules={checkinRules}
					onClose={closeRulesModal}
					onSubmit={acceptRules}
				/>
			)}
		</>
	);
};

export default StartCheckInNotification;
